import {
  colorCss,
  fontSizeCss,
  mobileColorCss,
  mobileFontSizeCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

type FieldIconUiNewProps = {
  color?: string
  mobileColor?: string
  fontSize?: number
  mobileFontSize?: number
}

const FieldIconUiNew = styled.i<FieldIconUiNewProps>`
  color: initial;
  top: 50%;
  right: 10px;
  transform: translate(0, -50%);
  && {
    position: absolute;
  }
  ${colorCss}
  ${fontSizeCss}

  ${p => p.theme.phone} {
    right: 10px;
    ${mobileColorCss}
    ${mobileFontSizeCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      left: 10px;
      ${mobileColorCss}
      ${mobileFontSizeCss}
    `}
`

export default FieldIconUiNew
